<template>
  <div class="h-[258px] w-full">
    <div class="font-semibold text-20 mb-4">Popüler Testler</div>
    <div v-if="loading" class="u-center h-64">
      <OLoading />
    </div>
    <div v-else class="flex flex-wrap">
      <a v-for="article in list" :key="article._id" :href="getArticleUrl({ article })" :title="article.title" class="flex w-1/2 mb-4 pr-2">
        <div class="relative">
          <OImage
            v-if="isVideoArticle(article)"
            loading="lazy"
            src="/images/video-play-button.svg"
            class="absolute z-1 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-2/5 w-2/5 pointer-events-none"
          />
          <OImage
            loading="lazy"
            :src="getImageUrl(article.image)"
            class="h-15 min-w-[90px] w-[90px] object-cover mr-2"
            :alt="article.title"
          />
        </div>
        <div class="line-clamp-3 text-md font-medium leading-20 hover:text-o-blue">
          {{ article.title }}
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import { defineComponent, onBeforeMount, ssrRef, useContext } from '@nuxtjs/composition-api';
import { hasArticleCategory } from '~/modules/article/utils/articleUtils';
import { getImageUrl } from '~/modules/common/utils/imageUtils';
import { getArticleUrl } from '~/modules/common/utils/routingUtils';
import { localStore } from '~/modules/common/utils/localStorageUtils';
import { OLoading, OImage } from '~/modules/common/components/ui';

export default defineComponent({
  components: { OLoading, OImage },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const list = ssrRef([]);
    const loading = ssrRef(false);
    const { $service } = useContext();
    onBeforeMount(async () => {
      const popularTestArticlesLocalStore = localStore.getItem('o-popular-test-articles');
      if (popularTestArticlesLocalStore) {
        list.value = popularTestArticlesLocalStore;
      } else {
        loading.value = true;
        const { data: result } = await $service.category.getCategoryPopularFeed(props.id, 8);
        list.value = result;
        localStore.setItem('o-popular-test-articles', result, { expireMs: 60 * 5 }); // 5 mins
      }
      loading.value = false;
    });
    const isVideoArticle = (article) => hasArticleCategory(article, 'Video');
    return { loading, list, getImageUrl, getArticleUrl, isVideoArticle };
  },
});
</script>
